import { schoolImages } from '../data/images';

const schoolFacts = [
  { value: '1988', label: 'Established' },
  { value: '68,500', label: 'Square feet campus' },
  { value: '21', label: 'Classrooms' },
];

function About() {
  return (
    <main className="about-page" id="about">
      <section className="about-hero" aria-labelledby="about-title">
        <div className="about-hero-inner">
          <div className="about-hero-copy">
            <p className="about-eyebrow">Our story, our strength</p>
            <h1 id="about-title">Maa Umiya &amp; <span>School Overview</span></h1>
            <p className="about-lead">
              A school rooted in faith, community, and the promise of a modern education shaped by Indian values.
            </p>
          </div>
          <div className="about-emblem" aria-hidden="true">
            <span className="about-emblem-ring">विद्या ददाति विनयं</span>
            <span>Knowledge · Character · Community</span>
          </div>
        </div>
      </section>

      <div className="about-content">
        <div className="about-container">
          <section className="about-story" aria-labelledby="maa-umiya-title">
            <div className="about-story-mark" aria-hidden="true">Maa<br />Umiya</div>
            <div className="about-story-copy">
              <p className="about-section-kicker">A heritage of devotion</p>
              <h2 id="maa-umiya-title">Maa Umiya</h2>
              <p>
                Maa Umiya is an incarnation of Goddess Bhagwati Shailputri and the power-form consort of Lord Shiva, Goddess Parvati. While undergoing severe penance to attain Lord Shiva, Goddess Parvati became extremely frail. Her mother, Mainavati, uttered words of surprise and concern upon seeing her state, from which the name “Maa Umiya” became famous.
              </p>
              <p>
                The primary seat of Maa Umiya is located in Unjha, Mehsana district, Gujarat. A 1,200-year-old temple stands there, where Maa Umiya is revered as the clan deity (Kuldevi) of the Kurmi, Patel, and Patidar communities. Devotees from across India and abroad visit to seek her blessings, and grand festivals are organized at the temple during Navratri and other special occasions.
              </p>
            </div>
          </section>

          <section className="about-facts" aria-label="School facts">
            <div className="about-facts-inner">
              {schoolFacts.map((fact) => (
                <div className="about-fact" key={fact.label}>
                  <strong>{fact.value}</strong>
                  <span>{fact.label}</span>
                </div>
              ))}
            </div>
          </section>

          <section className="about-school" aria-labelledby="school-overview-title">
            <div className="about-school-heading">
              <p className="about-section-kicker">Growing with every generation</p>
              <h2 id="school-overview-title">School at a Glance<span>...</span></h2>
            </div>
            <div className="about-school-content">
              <p>
                Shree Umiya Patidar Higher Secondary School, located in Tillor Khurd, is a co-educational institution catering to students from Nursery to Class 12. The school campus spans approximately 68,500 square feet, which includes various sports grounds.
              </p>
              <p>
                The school was established on August 15, 1988. The contributions of founding member Shri Kailashchandra Ji (Babuji) remain unforgettable. Supported by the community, village, and parents, the school has consistently progressed over the last 34 years. Starting with just 2 classrooms, it now boasts 35 classrooms equipped with modern resources and amenities.
              </p>
              <p>
                The school building features an attractive layout, high security, and state-of-the-art facilities, currently educating 500 students. The institution continuously strives to blend modern education with traditional Indian values.
              </p>
            </div>
          </section>

          <section className="about-closing" aria-label="School identity">
            <img src={schoolImages.logo} alt="Shree Umiya Patidar SchoolShri Umiya Patidar Higher Secondary School emblem" />
            <p>Built by the community. Inspired by Maa Umiya. Preparing learners for tomorrow.</p>
          </section>
        </div>
      </div>
    </main>
  );
}

export default About;